import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { WrestlerWaiver } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';

/**
 * Service to save a wrestler waiver data
 */
@Injectable()
export class WrestlerWaiverService {
    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Add or update a wrestler waiver
     */
    public save(eventId: string, wrestlerId: string, wrestlerWaiver: WrestlerWaiver): Observable<WrestlerWaiver> {
        let response: Observable<IJsonApiResponse>;

        if (wrestlerWaiver.id) {
            // Update existing
            const apiRequestUrl: string = this.getApiUrl(eventId, wrestlerId) + wrestlerWaiver.id;
            response = this.http.patch(apiRequestUrl, wrestlerWaiver.serialize());
        } else {
            // Add new
            const apiRequestUrl: string = this.getApiUrl(eventId, wrestlerId);
            response = this.http.post(apiRequestUrl, wrestlerWaiver.serialize());
        }

        return response.pipe(map((response: IJsonApiResponse) => (new WrestlerWaiver()).deserialize(response)));
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(eventId: string, wrestlerId: string): string {
        return `${this.http.configService.getApiBaseUrl()}/events/${eventId}/wrestlers/${wrestlerId}/waivers/`;
    }
}
